const WEEKDAY_NAMES = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']

const holidayCache = {}

function pad2(value) {
  return String(value).padStart(2, '0')
}

function monthDayKey(date) {
  return `${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`
}

// Easter Sunday (Gregorian calendar) - Meeus/Jones/Butcher algorithm
function gregorianEaster(year) {
  const a = year % 19
  const b = Math.floor(year / 100)
  const c = year % 100
  const d = Math.floor(b / 4)
  const e = b % 4
  const f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3)
  const h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4)
  const k = c % 4
  const l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const month = Math.floor((h + l - 7 * m + 114) / 31)
  const day = ((h + l - 7 * m + 114) % 31) + 1
  return new Date(year, month - 1, day)
}

// Map of "MM-DD" -> holiday name (Polish public holidays) for the given year
function holidaysForYear(year) {
  if (holidayCache[year]) {
    return holidayCache[year]
  }

  // Fixed-date holidays
  const holidays = new Map([
    ['01-01', 'Nowy Rok'],
    ['01-06', 'Trzech Króli'],
    ['05-01', 'Święto Pracy'],
    ['05-03', 'Święto Konstytucji 3 Maja'],
    ['08-15', 'Wniebowzięcie NMP'],
    ['11-01', 'Wszystkich Świętych'],
    ['11-11', 'Święto Niepodległości'],
    ['12-25', 'Boże Narodzenie'],
    ['12-26', 'Drugi dzień Bożego Narodzenia'],
  ])

  // Christmas Eve (December 24) is a statutory day off only since 2025
  if (year >= 2025) {
    holidays.set('12-24', 'Wigilia')
  }

  // Movable feasts relative to Easter Sunday
  const easter = gregorianEaster(year)
  const movableFeasts = [
    [0, 'Wielkanoc'],
    [1, 'Poniedziałek Wielkanocny'],
    [49, 'Zielone Świątki'],
    [60, 'Boże Ciało'],
  ]
  movableFeasts.forEach(([offset, name]) => {
    const date = new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + offset)
    holidays.set(monthDayKey(date), name)
  })

  holidayCache[year] = holidays
  return holidays
}

// Normalizes a date (Date object or "YYYY-MM-DD" string) to a local Date object
function toDate(value) {
  if (value instanceof Date) {
    return value
  }
  if (typeof value === 'string') {
    const [year, month, day] = value.split('-').map(Number)
    if (year && month && day) {
      return new Date(year, month - 1, day)
    }
    const parsed = new Date(value)
    return Number.isNaN(parsed.getTime()) ? null : parsed
  }
  return null
}

export default {
  methods: {
    // Whether the given date is a statutory day off in Poland
    isPolishHoliday(date) {
      const parsed = toDate(date)
      if (!parsed) {
        return false
      }
      return holidaysForYear(parsed.getFullYear()).has(monthDayKey(parsed))
    },
    // Name of the Polish holiday for the given date (empty string if it is not a holiday)
    polishHolidayName(date) {
      const parsed = toDate(date)
      if (!parsed) {
        return ''
      }
      return holidaysForYear(parsed.getFullYear()).get(monthDayKey(parsed)) || ''
    },
    // Polish weekday name (e.g. "poniedziałek")
    polishWeekdayName(date) {
      const parsed = toDate(date)
      return parsed ? WEEKDAY_NAMES[parsed.getDay()] : ''
    },
  },
}
